export enum Role {
  Admin = "ADMIN",
  Pro = "PRO",
}
